

















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { MONTHS } from '@/constants'
import { EAdminTaskStatus, EOnboardingMilestoneStatus, IAdminTask, IOnboarding, IOnboardingMilestone, IOnboardingMilestoneTemplate } from '@zunta/configurations'
import { ChainModule } from '@/store/modules/chain.module'
import Icon from '@/components/Icon.vue'
import OnboardingSettingsModal from './OnboardingSettingsModal.vue'
import Accordion from '@/components/Accordion.vue'

const groupBy = require('lodash.groupby')
const sortBy = require('lodash.sortby')
@Component({
  components: {
    Card,
    Checkbox,
    Icon,
    OnboardingSettingsModal,
    Accordion
  },
  props: {
    onboarding: {
      type: Object,
      required: true
    },
    milestones: {
      type: Array,
      required: true
    }
  }
})
export default class OnboardingDetails extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)

  EOnboardingMilestoneStatus: any = EOnboardingMilestoneStatus;
  selectedOnboarding: IOnboarding | null = null;

  get tasks () {
    return this.$store.state.chain.adminTasks.filter((adminTask: IAdminTask) => adminTask.status === EAdminTaskStatus.TODO)
  }

  get groupedMilestones () {
    const milestones = this.$props.milestones
    const group: any[] = []
    const groupedByParent = groupBy(milestones, (milestone: IOnboardingMilestone) => (
      (milestone.template as IOnboardingMilestoneTemplate).parent || '0'
    ))
    const parents = groupedByParent['0']
    const groupedById = groupBy(milestones, (milestone: IOnboardingMilestone) => (
      (milestone.template as IOnboardingMilestoneTemplate).id
    ))
    Object.keys(groupedByParent).forEach((key) => {
      if (key === '0') return
      group.push({
        parent: groupedById[key][0],
        sub: sortBy(groupedByParent[key], (milestone: IOnboardingMilestone) => (
          (milestone.template as IOnboardingMilestoneTemplate).order
        ))
      })
    })
    parents.forEach((parent: IOnboardingMilestone) => {
      if (!group.find((item) => item.parent.id === parent.id)) {
        group.push({
          parent,
          sub: []
        })
      }
    })
    return sortBy(group, (group: any) => group.parent.template.order)
  }

  getTasksForMilestone (milestone: IOnboardingMilestone) {
    return this.tasks.filter((task: IAdminTask) => {
      return task.onboardingMilestone && ((task.onboardingMilestone as IOnboardingMilestone).template as IOnboardingMilestoneTemplate).id === (milestone.template as IOnboardingMilestoneTemplate).id
    })
  }

  getOnboardingDate () {
    const createdAt = new Date(this.$props.onboarding.createdAt)
    const monthIndex = createdAt.getMonth()
    const day = createdAt.getDate()
    return `${MONTHS[monthIndex]} ${day}`
  }

  async changeStatus (milestone: IOnboardingMilestone, event: any) {
    if (!event.target.checked) {
      if (this.getTasksForMilestone(milestone).length === 0) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'To uncheck milestone create task for it first',
          header: 'Can Not Uncheck Milestone',
          icon: 'error'
        })
        return false
      }
    }
    await this.chainModuleInstance.changeMilestoneStatus({
      milestone: milestone.id,
      status: event.target.checked ? EOnboardingMilestoneStatus.COMPLETE : EOnboardingMilestoneStatus.TODO
    })
  }
}
